import React from 'react';
import Link from '@cloudscape-design/components/link';
import Box from '@cloudscape-design/components/box';

export interface ExternalLinkItem {
  href: string;
  text: string;
}

export function ExternalLinkGroup({ items }: { items: ExternalLinkItem[] }) {
  return (
    <Box variant="p">
      <Box variant="h3">Learn more</Box>
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            <Link href={item.href} external>
              {item.text}
            </Link>
          </li>
        ))}
      </ul>
    </Box>
  );
}

export function InfoLink({ onFollow }: { onFollow: () => void }) {
  return (
    <Link variant="info" onFollow={onFollow}>
      Info
    </Link>
  );
}
